import { BillingContact, BillingContactAddress } from '@atlassian/cssxp-types-billing';
import { CONTACT_PATH } from '@atlassian/cssxp-typescommon';
import isEmpty from 'lodash/isEmpty';
import negate from 'lodash/negate';
import * as React from 'react';
import { Link } from 'react-router-dom';

export interface Props {
  contact?: BillingContact;
}

const getCityStatePostalCode = ({ city, state, postalCode }: BillingContactAddress): string => {
  if (city && state) {
    return postalCode && !isEmpty(postalCode) ? `${city}, ${state} ${postalCode}` : `${city}, ${state}`;
  }

  return [city, state, postalCode].filter(negate(isEmpty)).join(' ');
};

const BillingDocContactDetailBlockV2 = ({ contact }: Props) => {
  if (!contact) {
    return <div>Contact not found</div>;
  }

  const displayName = contact.fullName ?? 'No name';

  return (
    <div className="contact-detail" data-testid={`billing-doc-contact-${contact.email}`}>
      <div className="contact-detail-name" data-testid="billing-doc-contact-name">
        <strong>
          <Link to={contact.email ? `${CONTACT_PATH}/${contact.email}` : '#'}>{displayName}</Link>
        </strong>
      </div>
      {contact.email && <div className="contact-detail-email">{contact.email}</div>}
      {contact.organization && (
        <div className="contact-detail-organization">
          <strong>{contact.organization}</strong>
        </div>
      )}
      {contact.address.address1 && <div className="contact-detail-address">{contact.address.address1}</div>}
      {contact.address.address2 && <div className="contact-detail-address">{contact.address.address2}</div>}
      <div className="contact-detail-city" data-testid="contact-detail-city-state">
        {getCityStatePostalCode(contact.address)}
      </div>
      {contact.address.country && <div className="contact-detail-country">{contact.address.country}</div>}
      {contact.taxId && <div className="contact-detail-tax-id">Tax ID: {contact.taxId}</div>}
    </div>
  );
};

export default BillingDocContactDetailBlockV2;
